/* BROOT — interior page art layer.
   Full treatment where a .bx-page body exists; on every other template it
   degrades to the scroll-progress hairline only. Pure progressive enhancement. */
(function () {
  if (window.__brootInter) return; window.__brootInter = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var page = document.querySelector('.bx-page');
    var lite = !page;
    var orbs = [], secs = [], dots = [], rvTargets = [];

    /* ---------- 1. Background artwork (content pages only) ---------- */
    if (!lite) {
      var bg = document.createElement('div');
      bg.className = 'in-bg';
      bg.setAttribute('aria-hidden', 'true');
      bg.innerHTML =
        '<b></b><b></b><b></b>' +
        '<svg class="in-grid" viewBox="0 0 100 100" preserveAspectRatio="none">' +
        '<line x1="20" y1="0" x2="20" y2="100"/><line x1="50" y1="0" x2="50" y2="100"/>' +
        '<line x1="80" y1="0" x2="80" y2="100"/></svg>';
      document.body.insertBefore(bg, document.body.firstChild);
      orbs = bg.querySelectorAll('b');
    }

    /* ---------- 2. Scroll progress hairline (every template) ---------- */
    var prog = document.createElement('div');
    prog.className = 'in-prog'; prog.setAttribute('aria-hidden', 'true');
    document.body.appendChild(prog);

    if (!lite) {
      /* ---------- 3. Section discovery + index rail ---------- */
      secs = Array.prototype.slice.call(page.children).filter(function (el) {
        return el.offsetHeight > 240;
      });
      if (secs.length > 2) {
        var idx = document.createElement('nav');
        idx.className = 'in-idx is-live';
        idx.setAttribute('aria-hidden', 'true');
        secs.forEach(function () { idx.appendChild(document.createElement('i')); });
        document.body.appendChild(idx);
        dots = idx.querySelectorAll('i');
      }

      /* ---------- 4. Reveal tagging ---------- */
      secs.forEach(function (sec) {
        var kids = Array.prototype.slice.call(sec.querySelectorAll(':scope > * , :scope > * > *'));
        var seen = 0;
        kids.forEach(function (k) {
          if (seen > 26) return;
          if (k.classList.contains('in-rv') || k.classList.contains('ar-rv')) return;
          if (!k.offsetHeight || k.offsetHeight > window.innerHeight * 1.4) return;
          if (/^(BR|SCRIPT|STYLE|SOURCE|PICTURE|IMG)$/.test(k.tagName)) return;
          var cs = window.getComputedStyle(k);
          if (cs.position === 'absolute' || cs.position === 'fixed') return;
          k.classList.add('in-rv');
          k.style.transitionDelay = ((seen % 5) * 0.055).toFixed(3) + 's';
          rvTargets.push(k); seen++;
        });
      });

      /* ---------- 5. Image masking + parallax ---------- */
      Array.prototype.forEach.call(page.querySelectorAll('img'), function (img) {
        var host = img.parentElement;
        if (!host || host.classList.contains('in-mask')) return;
        if (img.offsetHeight < 140) return;
        img.classList.remove('in-rv');
        img.style.transitionDelay = '';
        if (host.children.length > 2) {
          var w = document.createElement('span');
          w.className = 'in-mask in-mask--rel'; w.style.display = 'block';
          host.insertBefore(w, img); w.appendChild(img);
          host = w;
        } else {
          var hp = window.getComputedStyle(host).position;
          host.classList.add('in-mask');
          if (hp === 'static') host.classList.add('in-mask--rel');
        }
        host.classList.remove('in-rv');
        host.style.transitionDelay = '';
        rvTargets.push(host);
        /* decorative sweep is a real element — never a pseudo, so we never
           clobber an existing ::before/::after scrim on the host */
        if (!reduce && window.getComputedStyle(host).position !== 'static') {
          var sw = document.createElement('i');
          sw.className = 'in-sweep';
          sw.setAttribute('aria-hidden', 'true');
          host.appendChild(sw);
        }
        if (!reduce) img.setAttribute('data-ar-px', '22');
      });

      /* ---------- 6. Typography motion on headings ---------- */
      Array.prototype.forEach.call(page.querySelectorAll('h1,h2'), function (h) {
        if (h.children.length) return;
        if ((h.textContent || '').trim().length > 130) return;
        h.classList.remove('in-rv'); h.style.transitionDelay = '';
        h.classList.add('ar-lines');
      });

      /* ---------- 7. Mobile: fold a genuine wall of words ---------- */
      if (window.matchMedia('(max-width:767px)').matches) {
        var used = [];
        Array.prototype.forEach.call(page.querySelectorAll('p,ul,ol'), function (b) {
          if (used.indexOf(b) > -1) return;
          var run = [b], n = b.nextElementSibling;
          while (n && /^(P|UL|OL)$/.test(n.tagName)) { run.push(n); n = n.nextElementSibling; }
          run.forEach(function (x) { used.push(x); });
          if (run.length < 3) return;
          var h = run.reduce(function (a, x) { return a + x.getBoundingClientRect().height; }, 0);
          if (h < window.innerHeight * 1.15) return;
          var wrap = document.createElement('div');
          wrap.className = 'in-fold';
          b.parentNode.insertBefore(wrap, b);
          run.forEach(function (x) { wrap.appendChild(x); x.classList.remove('in-rv'); x.style.transitionDelay = ''; });
          var btn = document.createElement('button');
          btn.type = 'button'; btn.className = 'in-more'; btn.textContent = 'Read more';
          btn.setAttribute('aria-expanded', 'false');
          wrap.parentNode.insertBefore(btn, wrap.nextSibling);
          btn.addEventListener('click', function () {
            var open = wrap.classList.toggle('is-open');
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
            btn.textContent = open ? 'Show less' : 'Read more';
            if (!open) wrap.scrollIntoView({ block: 'start', behavior: 'smooth' });
          });
        });
      }

      /* ---------- 8. Floating decorative elements ---------- */
      if (!reduce) {
        var kinds = [
          { c: 'r', s: 'width:110px;height:110px' },
          { c: 'd', s: 'width:6px;height:6px' },
          { c: 'l', s: 'width:1px;height:120px' },
          { c: 'r', s: 'width:46px;height:46px' },
          { c: 'x', s: '', t: '01' },
          { c: 'd', s: 'width:4px;height:4px' },
          { c: 'l', s: 'width:1px;height:76px' },
          { c: 'x', s: '', t: '·' }
        ];
        secs.forEach(function (sec, i) {
          if (i % 2) return;
          if (window.getComputedStyle(sec).position === 'static') sec.style.position = 'relative';
          for (var j = 0; j < 2; j++) {
            var k = kinds[(i + j * 3) % kinds.length];
            var f = document.createElement('span');
            f.className = 'in-float ' + k.c;
            f.setAttribute('aria-hidden', 'true');
            f.style.cssText = k.s;
            f.style.top = (12 + ((i * 23 + j * 47) % 66)) + '%';
            f.style[j % 2 ? 'right' : 'left'] = (3 + ((i * 7 + j * 11) % 12)) + '%';
            if (k.t) f.textContent = k.t;
            sec.appendChild(f);
          }
        });
      }

      /* ---------- 9. Reveal observer ---------- */
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          en.forEach(function (x) {
            if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); }
          });
        }, { threshold: 0.08, rootMargin: '0px 0px -3% 0px' });
        rvTargets.forEach(function (e) { io.observe(e); });
      } else {
        rvTargets.forEach(function (e) { e.classList.add('is-in'); });
      }
    }

    /* ---------- 10. Scroll loop ---------- */
    var q = false;
    function frame() {
      q = false;
      var y = window.scrollY || 0;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      prog.style.transform = 'scaleX(' + (max > 0 ? clamp(y / max, 0, 1) : 0).toFixed(4) + ')';
      if (!reduce) {
        for (var i = 0; i < orbs.length; i++) {
          orbs[i].style.transform = 'translate3d(0,' + (-y * (0.06 + i * 0.045)).toFixed(1) + 'px,0)';
        }
      }
      if (dots.length) {
        var vh = window.innerHeight, act = 0;
        for (var s = 0; s < secs.length; s++) {
          if (secs[s].getBoundingClientRect().top <= vh * 0.45) act = s;
        }
        for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-on', d === act);
      }
    }
    window.addEventListener('scroll', function () { if (!q) { q = true; requestAnimationFrame(frame); } }, { passive: true });
    window.addEventListener('resize', frame, { passive: true });
    frame();

    /* safety net: anything still hidden after 2.5s gets shown */
    setTimeout(function () {
      rvTargets.forEach(function (e) {
        var r = e.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) e.classList.add('is-in');
      });
    }, 2500);
  });
})();
